import React, { Dispatch, SetStateAction } from "react";
import { Modal } from "react-bootstrap";
import { ActionHandlerFunction, AdminApprovalGroup, AdminUserBase, OrgInfo } from "@preveil-api";
import { Account, account_types, AdminUIActionTypes, OrganizationInformation } from "src/common";
import { CreateForm } from "../..";
import _ from "lodash";

type AllProps = {
  approval_groups: AdminApprovalGroup[];
  create_modal_show: boolean;
  copied_approval_group?: AdminApprovalGroup;
  handleAction: ActionHandlerFunction;
  setCopiedApprovalGroup: Dispatch<SetStateAction<AdminApprovalGroup | undefined>>;
  organization_info: OrganizationInformation;
  current_account: Account;
  org_info: OrgInfo;
};

// Description: Modal component for creating a new approval group
function CreateModalComponent(props: AllProps) {
  const { create_modal_show, copied_approval_group, handleAction, setCopiedApprovalGroup, organization_info, approval_groups, current_account, org_info } = props;

  return (
    <Modal
      size="lg"
      show={create_modal_show}
      onHide={() => { setCopiedApprovalGroup(undefined); handleAction({ actionType: AdminUIActionTypes.SetShow }); }}
      centered
      aria-label="Create Approval Group"
    >
      <Modal.Header>
        <Modal.Title>Create Approval Group</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CreateForm
          approval_groups={approval_groups}
          copied_approval_group={copied_approval_group}
          handleAction={handleAction}
          setCopiedApprovalGroup={setCopiedApprovalGroup}
          org_full_users={_.filter(organization_info.lightweight_org_users, ((_users: AdminUserBase) => _users.account_type === account_types.full))}
          current_account={current_account}
          org_info={org_info}
        />
      </Modal.Body>
    </Modal>
  );
}

export default React.memo(CreateModalComponent);
